import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styled from "styled-components";


const EmailCampaignSidebarWrapper = styled.div`
  width: 250px;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;
  margin-left: -20px;
  margin-top: -40px;

  height: auto;
  position:sticky;
`;

const EmailCampaignSidebarInnerWrapper = styled.div`
  width: 250px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
`;

const EmailCampaignSidebarItems = styled.div`
  margin-top: 20px;
`;

const EmailCampaignSidebarItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const EmailCampaignSidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const EmailCampaignSidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const EmailCampaignSidebar = ({
  emailCampaignId,
  defaultSelectedTab = window.location.hash ? window.location.hash.substr(1) : "details",
  onNavItemClicked = () => { },
}) => {
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);

  useEffect(() => {
    setSelectedTab(defaultSelectedTab);
  }, [defaultSelectedTab]);

  useEffect(() => {
    window.history.pushState(null, null, `#${selectedTab}`);
    onNavItemClicked(selectedTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  const selectTab = (tab) => {
    setSelectedTab(tab);
    // Update to use the has of the tab
  };

  const isSelected = (tab) => {
    console.log("!!! CHECKING IF SELECTED: ", tab, selectedTab, selectedTab === tab);
    return selectedTab === tab ? "active" : "";
  }


  return (
    <EmailCampaignSidebarWrapper
      className={
        "block top-0 bottom-0 w-64 bg-white left-0 absolute flex-row flex-nowrap md:z-10 z-9999 transition-all duration-300 ease-in-out transform "
      }
      style={{}}
    >
      <EmailCampaignSidebarInnerWrapper>
        <EmailCampaignSidebarItems style={{ flexGrow: 0 }}>
          <EmailCampaignSidebarItem className={isSelected("details")} onClick={() => selectTab("details")}>
            <span>
              <EmailCampaignSidebarItemIcon icon="lucide:info" />
            </span>
            <EmailCampaignSidebarItemText>Details</EmailCampaignSidebarItemText>
          </EmailCampaignSidebarItem>
          <EmailCampaignSidebarItem className={isSelected("recipients")} onClick={() => selectTab("recipients")}>
            <span>
              <EmailCampaignSidebarItemIcon icon="lucide:files" />
            </span>
            <EmailCampaignSidebarItemText>Recipients</EmailCampaignSidebarItemText>
          </EmailCampaignSidebarItem>
        </EmailCampaignSidebarItems>
      </EmailCampaignSidebarInnerWrapper>
    </EmailCampaignSidebarWrapper>
  );
};

export default EmailCampaignSidebar;
